// extracted by css-extract-rspack-plugin
export default {"thinkingContent":"ThinkingBlock-module__thinkingContent__KLtcS"};